import routerOptions0 from "/opt/build/repo/node_modules/.pnpm/nuxt@3.17.3_@netlify+blobs@9.1.1_@parcel+watcher@2.5.1_@types+node@22.15.18_db0@0.3.2_e_498822e4df205a3bc1423f37fffbcf8d/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/opt/build/repo/app/router.options.ts";
const configRouterOptions = {
  scrollBehaviorType: "smooth",
  hashMode: false
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}